import type { ReactNode } from "react";
import { C } from "./theme.ts";

/**
 * Componentes compartidos del sistema de diseño (issue #47). Antes cada vista
 * tenía su copia con derivas (dos Chips distintos, `dinero` con dos fallbacks).
 * Esta es la versión canónica; las vistas no definen las suyas.
 */

export type TonoChip = "verde" | "ambar" | "rojo" | "gris" | "tiel" | "azul";

const TONOS: Record<TonoChip, { c: string; bg: string }> = {
  verde: { c: C.green, bg: C.greenBg },
  ambar: { c: C.amber, bg: C.amberBg },
  rojo: { c: C.red, bg: C.redBg },
  gris: { c: C.muted, bg: C.grayBg },
  tiel: { c: C.tielDark, bg: C.tielSoft },
  azul: { c: C.blue, bg: C.blueBg },
};

export function Chip({ tono, children }: { tono: TonoChip; children: ReactNode }) {
  const m = TONOS[tono];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "2px 9px",
        borderRadius: 999,
        fontSize: 11.5,
        fontWeight: 600,
        color: m.c,
        background: m.bg,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}

export function Fila({ k, v }: { k: string; v: string }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: 12,
        fontSize: 13.5,
        padding: "3px 0",
      }}
    >
      <span style={{ color: C.muted }}>{k}</span>
      <span style={{ fontWeight: 600, textAlign: "right", color: C.ink, fontVariantNumeric: "tabular-nums" }}>{v}</span>
    </div>
  );
}
